var exports = {
  "k": "xdbfd91f1--a16cd1--container",
};

module.exports = exports;
